import { usePostHog } from "@posthog/react";

import {
  trackCtaClicked as sharedTrackCtaClicked,
  trackCtaEvent as sharedTrackCtaEvent,
  trackPageOpened as sharedTrackPageOpened,
  type TrackCtaClickedInput,
  type TrackCtaEventInput,
  type TrackPageOpenedInput,
} from "../lib/analytics/posthog";

const useSchedulerAnalytics = () => {
  const posthog = usePostHog();

  return {
    trackPageOpened: (input?: TrackPageOpenedInput) =>
      sharedTrackPageOpened(posthog, input),
    trackCtaEvent: (input: TrackCtaEventInput) =>
      sharedTrackCtaEvent(posthog, input),
    trackCtaClicked: (input: TrackCtaClickedInput) =>
      sharedTrackCtaClicked(posthog, input),
  };
};

export default useSchedulerAnalytics;
